import { meContext } from '@ooh/contracts';
import { useApiQuery } from './use-api-query';

// Same key as the web app's own context query, so both read one cached /me/context entry.
export const ME_CONTEXT_QUERY_KEY = ['me', 'context'] as const;

const ME_CONTEXT_STALE_TIME_MS = 300_000;

// Capabilities (permission codes and feature flags) come from /me/context, not from the current-user plug.
// Fails open while loading; the server enforces the real rule.
export function useHasCapability(key: string): boolean {
  const { data } = useApiQuery(
    meContext.get,
    {},
    {
      queryKey: ME_CONTEXT_QUERY_KEY,
      staleTime: ME_CONTEXT_STALE_TIME_MS,
      select: (response) => response.capabilities,
    },
  );
  return data == null || data.includes(key);
}
